// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4c930901","692":"b8904c95"}[chunkId] + ".chunk.js";
};